const fields = (t) => ({
    config: {columns: 2},
    fields: [
        {
            name: "blisterImages",
            label: t ? t("common.photos") : "Zdjęcia blistra",
            column: 1,
            type: "file",
        },
        {
            name: "validationDocumentation",
            label: t ? t("forms.validation_documentation") : "Dokumentacja walidacyjna",
            column: 1,
            type: "file",
        },
        {
            name: "certificates",
            label: t ? t("forms.certificates") : "Certyfikaty",
            column: 2,
            type: "file"
        },
        {
            name: "otherFiles",
            label: t ? t("forms.other_files") : "Inne pliki",
            column: 2,
            type: "file",
        }
    ]
});

export default fields;
